// Central query-key registry so the SSE hook can invalidate precisely.
export const qk = {
  me: ["me"] as const,
  selected: (params?: Record<string, string>) => ["selected", params ?? {}] as const,
  selectedOne: (id: string) => ["selected", id] as const,
  /** R-005: distinct `Selected.Team` values for the Find Preprint team filter. */
  selectedTeams: ["selected", "teams"] as const,
  preprints: (params?: Record<string, string>) => ["preprints", params ?? {}] as const,
  preprintOne: (id: string) => ["preprint", id] as const,
  referees: (preprintId: string) => ["referees", preprintId] as const,
  proposals: (params?: Record<string, string>) => ["proposals", params ?? {}] as const,
  proposalOne: (id: string) => ["proposal", id] as const,
  qc: (params?: Record<string, string>) => ["qc", params ?? {}] as const,
  /** Frida-QC R-002: distinct proposal Team values for the QC team filter. */
  qcTeams: ["qc", "teams"] as const,
  operations: (params?: Record<string, string>) => ["operations", params ?? {}] as const,
  reports: ["reports"] as const,
  /** July-14 role dashboards (FR-P1/P2). */
  dashboardAe: (editor?: string) => ["dashboard", "ae", editor ?? "self"] as const,
  /** WO-7/21 Track A: the Productivity view (period-scoped staff overview + AE drill-down). */
  productivityStaff: (from: string, to: string) => ["dashboard", "staff", "productivity", from, to] as const,
  productivityAe: (editor: string, from: string, to: string) =>
    ["dashboard", "ae", "productivity", editor, from, to] as const,
  /** Productivity Tab v3: the staff Team / Student productivity roster. */
  productivityStudents: (from: string, to: string) =>
    ["dashboard", "students", "productivity", from, to] as const,
  dashboardStudent: ["dashboard", "student"] as const,
  /** iter2: self-scoped student productivity + badges (from = "" when all-time).
   *  `student` is set when an AE opens another student's progress. */
  myProductivity: (from: string, to: string, student = "") =>
    ["dashboard", "my-productivity", from, to, student] as const,
  dashboardStaff: ["dashboard", "staff"] as const,
  /** Admin home "Journal Pipeline" (WO-2026-08-19) — team-grouped rollup. */
  dashboardAdmin: ["dashboard", "admin"] as const,
  notifications: ["notifications"] as const,
  adminStatus: ["admin", "status"] as const,
  /** COI backend observability pull (A3) — GET /api/admin/coi/status. */
  adminCoiStatus: ["admin", "coi-status"] as const,
  /** COI dual-write New lane (workorder §2.3) — GET /api/admin/coi/new-lane. */
  adminCoiNewLane: ["admin", "coi-new-lane"] as const,
  /** Feature flags from GET /api/health (FEATURE_COI gating, B3). */
  features: ["features"] as const,
  /** Staging/dev Data Ops — GET /api/admin/dataops/snapshots. */
  adminDataOpsSnapshots: ["admin", "dataops", "snapshots"] as const,
  /** Staging/dev Data Ops — GET /api/admin/dataops/runs. */
  adminDataOpsRuns: ["admin", "dataops", "runs"] as const,
  /** Staging/dev Data Ops canary — GET /api/admin/dataops/canary. */
  adminDataOpsCanary: ["admin", "dataops", "canary"] as const,
  /** Snapshot content diff — GET /api/admin/dataops/snapshots/diff?a&b. */
  adminDataOpsDiff: (a: string, b: string) =>
    ["admin", "dataops", "diff", a, b] as const,
  reportsLogins: ["reports", "logins"] as const,
  reportsAuditUi: ["reports", "audit", "ui"] as const,
};

/** Top-level key prefixes the SSE hook invalidates per event type. */
export const PREFIX = {
  preprint: ["preprints", "preprint", "selected", "operations", "dashboard"],
  reviewer: ["proposals", "proposal", "qc", "referees", "preprints", "preprint", "dashboard"],
  coi: ["proposals", "proposal", "qc", "dashboard"],
  notification: ["notifications"],
} as const;
